import React, { useState } from "react";
import { Drawer } from "@mantine/core";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";
import SurveyForm from "./SurveyForm";

const SurveyTableEmptyStateContainer: React.FC = () => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        opened={opened}
        size="full"
        onClose={() => setOpened(false)}
        title="Create Survey"
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <div
          style={{
            backgroundColor: "#f7f7f8",
            height: "100vh",
            overflow: "auto",
            padding: "25px"
          }}
        >
          <SurveyForm onSuccess={() => setOpened(false)} />
        </div>
      </Drawer>
      <EmptyStateContainer
        title="Create your first survey"
        description="You can build questionnaires and view employee responses via our dashboards"
        button={{
          onClick: () => setOpened(true),
          title: "Create Survey",
        }}
      />
    </>
  );
};

export default SurveyTableEmptyStateContainer;
